import { RequirementDefinitionSignatureFormValues } from "../../../../types";

export const getSignatureSettings = (
  settings: Partial<RequirementDefinitionSignatureFormValues>
): string[] => {
  const items: string[] = [];

  items.push(
    settings.requiredSignatures === "mutual"
      ? "Both contractor and company signatures required"
      : "Contractor signature required only"
  );

  items.push(`Template ID: ${settings.signedDocumentTemplateId}`);

  return items;
};
